import React from "react";
import { getActiveCatalogProducts, getProductChoiceError } from "../utils/productCatalog.js";

export default function DataManagerProductSelect({ products = [], value = "", originalValue,
  optional = false, loaded = true, disabled = false, onChange, ...props }) {
  const options = getActiveCatalogProducts(products);
  const error = getProductChoiceError(value, products, { originalValue, optional });
  const hasUnavailableValue = Boolean(value) && !options.some((product) => product.name === value);
  return (
    <select {...props} aria-label={props["aria-label"] || "Produit"} aria-invalid={Boolean(error) || undefined}
      disabled={disabled || !loaded} required={!optional} value={value || ""}
      title={!loaded ? "Chargement des produits..." : error || props.title}
      onChange={(event) => onChange(event.target.value)}>
      <option value="" disabled={!optional}>
        {!loaded ? "Chargement..." : options.length === 0 ? "Aucun produit actif" : optional ? "Non défini" : "Sélectionner..."}
      </option>
      {hasUnavailableValue ? <option value={value} disabled>{value} ({originalValue === value ? "ancien / inactif" : "à remplacer"})</option> : null}
      {options.map((product) => <option key={product.product_id} value={product.name}>{product.name}</option>)}
    </select>
  );
}
